import { priceFormate } from "../hooks/priceFormate";

import {
  COUPON_REPORT_LIST,
  DETAIL_CATEGORY_SALE_REPORT,
  DETAILED_LOYALTY_POINTS,
  DISCOUNT_PER_PERSON,
  DISCOUNT_SALES_TABLE_LIST,
  DROP_CASH_REPORT,
  EMPLOYEE_SALES_PER_CATEGORY_REPORT,
  EMPLOYEE_SALES_REPORT,
  EMPLOYEE_WORK_HOURS,
  GET_ITEMWISE_SALE_LIST,
  GET_PAYMENT_REPORT_DATA,
  GET_REGISTER_CLOSURE_LIST,
  GET_TOP_CATEGORY_SALES_REPORT_LIST,
  GIFT_CARD_REPORT,
  LIST_ALL_EMPLOYEE,
  LIST_ALL_ORDER_TYPE,
  LIST_DAILY_REPORT,
  NET_SALES_BY_EMPLOYEE_REPORT,
  NEW_CUSTOMER_ADDED_REPORT,
  NEW_CUSTOMER_REPORT,
  NEW_TAXES_REPORT,
  ORDER_REFUND_REPORT,
  PAY_IN_REPORT,
  Product_Profitability_REPORT,
  SALES_BY_HOURS_REPORT,
  SALES_REPORT_LIST,
  STORE_CREDIT_REPORT,
  TIP_REPORT_LIST,
  TOP_SALLER_REPORT,
  LIST_ALL_STORE_ORDER_LIST_NEW,
  LOTTERY_ACTIVITY_REPORT,
} from "./Config";
export function createdAt(date) {
  const year = date?.getFullYear();
  const month = String(date?.getMonth() + 1)?.padStart(2, "0");
  const day = String(date?.getDate())?.padStart(2, "0");
  const hours = String(date?.getHours())?.padStart(2, "0");
  const minutes = String(date?.getMinutes())?.padStart(2, "0");
  const seconds = String(date?.getSeconds())?.padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const padZero = (input) => (input >= 10 ? input : `0${input}`);

// Date-only API values ("YYYY-MM-DD") -> "MM/DD/YYYY" without a Date object, so no timezone shift.
export function formatDateOnly(value, fallback = "") {
  if (value == null) return fallback;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value).trim());
  if (!match || match[1] === "0000") return fallback;
  return `${match[2]}/${match[3]}/${match[1]}`;
}

export function formatDate(inputDate, type = "") {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  if (inputDate == null || inputDate === "") {
    return "-";
  }

  let dateStr = inputDate;
  if (inputDate instanceof Date) {
    if (Number.isNaN(inputDate.getTime())) return "-";
    const y = inputDate.getFullYear();
    const m = String(inputDate.getMonth() + 1).padStart(2, "0");
    const d = String(inputDate.getDate()).padStart(2, "0");
    dateStr = `${y}-${m}-${d}`;
  } else {
    dateStr = String(inputDate).trim();
  }

  const datePart = dateStr.split("T")[0].split(" ")[0];
  if (!datePart || datePart.startsWith("0000-00-00")) {
    return "-";
  }

  const parts = datePart.split("-");
  if (parts.length < 3) {
    return "-";
  }

  const [year, month, dayRaw] = parts;
  const dayNum = parseInt(String(dayRaw).split(" ")[0], 10);
  if (!year || Number.isNaN(dayNum)) {
    return "-";
  }

  const monthName = months[parseInt(month, 10) - 1];
  if (!monthName) {
    return "-";
  }

  const day = padZero(dayNum);
  const formattedDateMonthDayYear = `${monthName} ${day}, ${year}`;
  const formattedDate = `${month}/${day}/${year}`;
  return type === "month date, year" ? formattedDateMonthDayYear : formattedDate;
}

export function formatDateNumeric(date) {
  if (!date) return "";
  const d = new Date(date);
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const year = d.getFullYear();
  return `${month}-${day}-${year}`;
}

export const formatAPIDate = (d) => {
  if (!d) return '';
  if (typeof d === 'string') {
    let dateStr = d;
    if (dateStr.includes('T')) {
       dateStr = dateStr.split('T')[0];
    }
    if (dateStr.includes('-')) {
       const parts = dateStr.split('-');
       if (parts.length >= 3) {
           const year = parts[0];
           const month = parts[1];
           const day = parts[2];
           return `${month}/${day}/${year}`;
       }
    }
  }
  
  const date = d instanceof Date ? d : new Date(d);
  if (isNaN(date.getTime())) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

// Convert a date to a relative "X days ago" string
export const formatDaysAgo = (input) => {
  if (!input) return "";

  const date = input instanceof Date ? input : new Date(input);
  if (isNaN(date.getTime())) return "";

  // Compare using local calendar days (ignore time-of-day)
  const today = new Date();
  const startOfToday = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const startOfTarget = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );

  const diffMs = startOfToday - startOfTarget;
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  const safeDays = days < 0 ? 0 : days; // guard against future dates
  return `${safeDays} day${safeDays === 1 ? "" : "s"} ago`;
};

export function formatDateTime(dateTimeStr) {
  // Split the input string into date and time parts
  if (!dateTimeStr) return "";
  const [datePart, timePart] = dateTimeStr?.split(" ");

  // Further split the date part into year, month, and day
  const [year, month, day] = datePart?.split("-");

  // Further split the time part into hours, minutes, and seconds
  const [hours, minutes] = timePart?.split(":")?.map(Number);

  // Convert 24-hour time to 12-hour format
  const period = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;

  // Create a new Date object using the extracted values
  const date = new Date(
    `${year}-${month}-${day}T${hours?.toString()?.padStart(2, "0")}:${minutes
      ?.toString()
      ?.padStart(2, "0")}:00`
  );

  // Define formatting options
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  // Format the date using Intl.DateTimeFormat
  const formattedDate = new Intl.DateTimeFormat("en-US", options)?.format(date);

  // Format the time
  const formattedTime = `${formattedHours
    ?.toString()
    ?.padStart(2, "0")}:${minutes?.toString()?.padStart(2, "0")}${period}`;

  return `${formattedDate} ${formattedTime}`;
}

export const CurrencyInputHelperFun = (value) => {
  let val = value?.replace(/[^\d]/g, "");

  if (val === "") {
    return "0.00";
  }

  val = val?.replace(/^0+/, "");

  while (val?.length < 3) {
    val = "0" + val;
  }

  const integerPart = val?.slice(0, val?.length - 2);
  const decimalPart = val?.slice(val?.length - 2);
  return `${integerPart}.${decimalPart}`;
};

export const disableZeroOnFirstIndex = (value) => {
  const charAtZero = value?.charAt(0);
  const startByZero = charAtZero == 0;
  const isBlank = value === "";
  const bool = startByZero && !isBlank;

  return bool;
};

export const handleInputNumber = (e, setDealInfo, dealInfo) => {
  const { value, name, selectionStart } = e.target;

  if (name === "minQty") {
    const qty = parseFloat(value) ? parseFloat(value) : 0;
    setDealInfo((prev) => ({ ...prev, minQty: qty }));
  }

  if (name === "maxQty") {
    const qty = value === "" ? null : parseFloat(value) ? parseFloat(value) : 0;
    setDealInfo((prev) => ({ ...prev, maxQty: qty }));
  }

  if (name === "discount") {
    const formattedValue = CurrencyInputHelperFun(value);
    const cursorAdjustment = formattedValue.length;
    if (parseFloat(formattedValue) > 99.99 && dealInfo?.isPercent === "1") {
      return;
    }
    if (name === "discount" && formattedValue.length > 1) {
      requestAnimationFrame(() => {
        e.target.setSelectionRange(
          selectionStart + cursorAdjustment,
          selectionStart + cursorAdjustment
        );
      });
    }
    setDealInfo((prev) => ({ ...prev, [name]: formattedValue }));
  }
};

export const validNumber = (input) =>
  parseFloat(input) && !isNaN(input) ? parseFloat(input) : 0;

export function isValidNumber(input) {
  // Check if the input is a number and is finite
  if (typeof input === "number" && isFinite(input)) {
    // Check if the number is a non-negative integer (not decimal and not negative)
    return input >= 0 && Number.isInteger(input);
  }
  // Return false if input is not a number
  return false;
}

// yyyy-mm-dd
export const dateInYYYYMMDD = (date) => {
  // Format date in yyyy-mm-dd using local time zone
  const year = date?.getFullYear();
  const month = String(date?.getMonth() + 1)?.padStart(2, "0"); // Month is 0-based, so we add 1
  const day = String(date?.getDate())?.padStart(2, "0"); // Pad single digits with leading zero
  return `${year}-${month}-${day}`;
};

export function formatToThousands(number) {
  if (number >= 1000000) {
    // Divide by 1,000,000 and round to 1 decimal place if needed
    const formatted = (number / 1000000)?.toFixed(1);
    // Remove the trailing .0 if it exists
    return `$${formatted?.endsWith(".0") ? formatted?.slice(0, -2) : formatted
      }M`;
  } else if (number >= 1000) {
    // Divide by 1,000 and round to 1 decimal place if needed
    const formatted = (number / 1000)?.toFixed(1);
    // Remove the trailing .0 if it exists
    return `$${formatted?.endsWith(".0") ? formatted?.slice(0, -2) : formatted
      }K`;
  }
  // If the number is less than 1000, return as is with dollar sign
  return `$${number}`;
}

function getFormattedDate(dateString, format) {
  const [year, month, newDate] = dateString ? dateString.split("-") : null;
  const date = dateString
    ? new Date(`${year}/${month}/${newDate}`)
    : new Date();

  // console.log("here date: ", date, dateString);
  if (format === "day-month") {
    return date?.toLocaleDateString("default", {
      day: "numeric",
      month: "short",
    }); // e.g., "26 Sept"
  }
  if (format === "month-year") {
    return date?.toLocaleDateString("default", {
      month: "short",
      year: "2-digit",
    }); // e.g., "Sept 24"
  }
}

// for charts - x axis dataset => [Sept 24, Aug 24, July 24..]
export function getXAxisData(option, dates) {
  const dateRanges = dates?.split(",");
  if (option === "Month") {
    // For month option, return the month and year from the first date of each range
    return dateRanges?.map((range) => {
      const [startDate] = range?.split("_"); // Get the start date
      return getFormattedDate(startDate, "month-year"); // e.g., "Sept 24"
    });
  }

  if (option === "Day") {
    // For day option, return the day and month from the single date in the range
    return dateRanges.map((range) => {
      const [startDate] = range.split("_"); // Get the single date
      return getFormattedDate(startDate, "day-month"); // e.g., "26 Sept"
    });
  }

  if (option === "Week") {
    // For week option, return the starting Monday of each week in the range
    return dateRanges.map((range) => {
      const [startDate] = range.split("_"); // Get the Monday date (first date of the range)
      return getFormattedDate(startDate, "day-month"); // e.g., "16 Sept"
    });
  }

  return [];
}

export const getYAxisTicks = (maxValue) => {
  const buffer = Math.ceil(maxValue * 1.1); // Add 10% buffer to maxValue
  const roundingFactor = Math.pow(10, Math.floor(Math.log10(buffer))); // Get the magnitude
  const roundedMax = Math.ceil(buffer / roundingFactor) * roundingFactor; // Round up

  // Calculate step for 5 unique points
  const step = roundedMax / 4;

  // Generate the 5 ticks from 0 to roundedMax
  const ticks = Array.from({ length: 5 }, (_, i) => step * i);

  // Format ticks based on maxValue criteria
  const formattedTicks = ticks.map((value) =>
    maxValue < 10 ? value.toFixed(2) : value.toFixed(0)
  );

  return formattedTicks;
};

// -------------------------------
// Get default date ranges based on the selected type
export function getDefaultDateRange(type, currentDate, options = {}) {
  // const currentDate = new Date();
  const result = [];
  const newDate = new Date(currentDate); // Use the current date for calculations

  if (type === "Day") {
    // Generate last 7 days
    for (let i = 0; i < 7; i++) {
      const startDate = new Date(newDate);
      result?.push(`${dateInYYYYMMDD(startDate)}_${dateInYYYYMMDD(startDate)}`);
      newDate?.setDate(newDate?.getDate() - 1);
    }
  } else if (type === "Week") {
    // Generate last 7 weeks
    const day = newDate?.getDay(); // 0=Sun
    const diffToMonday = day === 0 ? -6 : 1 - day;
    newDate?.setDate(newDate?.getDate() + diffToMonday); // Go to the Monday of the current week
    newDate?.setHours(0, 0, 0, 0);
    for (let i = 0; i < 7; i++) {
      const startDate = new Date(newDate);
      const endDate = new Date(startDate);
      endDate?.setDate(startDate?.getDate() + 6); // End on Sunday
      result?.push(`${dateInYYYYMMDD(startDate)}_${dateInYYYYMMDD(endDate)}`);
      newDate?.setDate(newDate?.getDate() - 7); // Go to the previous week
    }
  } else if (type === "Month") {
    // Generate last 7 months
    const monthCount =
      options && typeof options.monthCount === "number" && options.monthCount > 0
        ? options.monthCount
        : 12;
    for (let i = 0; i < monthCount; i++) {
      const startDate = new Date(
        newDate?.getFullYear(),
        newDate?.getMonth() - i,
        1
      );
      const endDate = new Date(
        newDate?.getFullYear(),
        newDate?.getMonth() - i + 1,
        0
      );
      result?.push(`${dateInYYYYMMDD(startDate)}_${dateInYYYYMMDD(endDate)}`);
    }
  }

  return {
    date_range: result.reverse().join(","), // Reverse to maintain the order
    present_date: newDate,
  };
}


// Function for Previous button
export function onPrevious(type, currentDate) {
  if (type === "Day") {
    currentDate?.setDate(currentDate?.getDate() - 1); // Go back 1 day
  } else if (type === "Week") {
    currentDate?.setDate(currentDate?.getDate() - 7); // Go back to previous week
  } else if (type === "Month") {
    currentDate?.setMonth(currentDate?.getMonth() - 1); // Go back 1 month
  }

  return currentDate;
  // return getDefaultDateRange(type, currentDate); // Get the updated date range
}

// Function for Next button
export function onNext(type, currentDate) {
  const today = new Date();
  const base = currentDate instanceof Date ? currentDate : new Date(currentDate);

  const isSameDayOrAfterToday = (date) => {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    return d.getTime() >= t.getTime();
  };

  const getWeekStartMonday = (date) => {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const day = d.getDay(); // 0=Sun
    const diff = day === 0 ? -6 : 1 - day;
    d.setDate(d.getDate() + diff);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const isSameWeekOrAfterCurrentWeek = (date) => {
    const weekStart = getWeekStartMonday(date);
    const currentWeekStart = getWeekStartMonday(today);
    return weekStart.getTime() >= currentWeekStart.getTime();
  };

  const isSameMonthOrAfterCurrentMonth = (date) => {
    const y = date.getFullYear();
    const m = date.getMonth();
    const ty = today.getFullYear();
    const tm = today.getMonth();
    return y > ty || (y === ty && m >= tm);
  };

  if (type === "Day") {
    if (isSameDayOrAfterToday(base)) return currentDate;
    base.setDate(base.getDate() + 1);
  } else if (type === "Week") {
    if (isSameWeekOrAfterCurrentWeek(base)) return currentDate;
    base.setDate(base.getDate() + 7);
  } else if (type === "Month") {
    if (isSameMonthOrAfterCurrentMonth(base)) return currentDate;
    base.setMonth(base.getMonth() + 1);
  }

  return base;
  // return getDefaultDateRange(type, currentDate); // Get the updated date range
}
export const removeCurrencySign = (tickItem) =>
  formatToThousands(tickItem)?.slice(1);

export const getStartDateAndEndDate = (dateRange) => {
  const allDates = dateRange?.split(",");
  const firstDate = allDates && allDates[0];
  const lastDate = allDates && allDates[allDates?.length - 1];

  const startDate = firstDate && firstDate?.split("_")[0];
  const endDate = lastDate && lastDate?.split("_")[1];

  return {
    startDate,
    endDate,
  };
};

export const generateClass = (str) => {
  if (str && str !== "") {
    const temp = str?.split(" ");
    const newTemp = temp?.join("-");

    const a = `${newTemp}-for-android`;
    // console.log("str: ", str, newTemp, a);
    return a;
  } else {
    return "";
  }
};

export const formatCurrency = (amount) => {
  const value = amount ? parseFloat(amount) : 0;
  const formattedAmount = Math.abs(value).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
  return value < 0 ? `-${formattedAmount}` : formattedAmount;
};

export const formatNumber = (value, options = {}) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "0";
  return num.toLocaleString("en-US", options);
};
export const percentageSign = (amount) => {
  return amount < 0 ? `-${amount}%` : `${amount}%`;
};
export const excelValue = (value, type) => {
  return value
    ? type === "dollar"
      ? `${priceFormate(formatCurrency(parseFloat(value).toFixed(2)))}`
      : type === "percent"
        ? `${priceFormate(parseFloat(value).toFixed(2))}%`
        : `${priceFormate(parseFloat(value).toFixed(2))}`
    : "";
};

export const getPercentValue = (oldInput, newInput) => {
  let percent = null;
  let oldValue = oldInput ? parseFloat(oldInput) : 0;
  let newValue = newInput ? parseFloat(newInput) : 0;

  if (oldValue == 0 && newValue == 0) {
    percent = null;
  } else if (oldValue > 0 && newValue == 0) {
    percent = -100;
  } else if (oldValue == 0 && newValue > 0) {
    percent = newInput;
  } else if (oldValue == 0 && newValue < 0) {
    percent = newInput;
  } else if (oldValue < 0 && newValue < 0) {
    const a = newValue - oldValue;
    const b = a / oldValue;
    const toShow = b * 100;
    const newIsBigger = newValue > oldValue;
    percent = newIsBigger ? Math.abs(toShow) : toShow * -1;
  } else {
    percent = ((newValue - oldValue) / oldValue) * 100;
  }
  return percent;
};

export const getLastRangeStartDate = (dateRangeString) => {
  // Split the string by commas to get individual ranges
  const ranges = dateRangeString.split(",");
  // Get the last range, split by underscore, and return the first part as the start date
  return ranges[ranges.length - 1].split("_")[0];
};

export const updateDataObject = (
  presentDate,
  activeType,
  merchantId,
  objectData,
  chartKey,
  data
) => {
  // Check if the merchantId exists in the data object
  if (!data[merchantId]) {
    data[merchantId] = {};
  }

  // Check if the activeType exists for the merchantId
  if (!data[merchantId][activeType]) {
    data[merchantId][activeType] = {};
  }

  // Check if the presentDate exists for the activeType
  if (!data[merchantId][activeType][presentDate]) {
    data[merchantId][activeType][presentDate] = {};
  }

  // Check if the chart data exists
  if (!data[merchantId][activeType][presentDate][chartKey]) {
    data[merchantId][activeType][presentDate][chartKey] = {};
  }

  // Merge the existing object with the new objectData
  data[merchantId][activeType][presentDate][chartKey] = {
    ...data[merchantId][activeType][presentDate][chartKey], // Existing keys
    ...objectData, // New keys
  };

  return data; // Return the updated data object
};

export const getMinMaxValues = (data) => {
  const maxUv = Math.max(...data.map((item) => item.uv));
  const minUv = Math.min(...data.map((item) => item.uv));

  return {
    maxUv,
    minUv,
  };
};

export const dataExists = (
  oldDashboardData,
  merchantId,
  activeType,
  date,
  chartKey
) => {
  // console.log("chartKey: ", chartKey);
  // console.log("oldDashboardData: ", oldDashboardData);

  if (!oldDashboardData[merchantId]) {
    return false;
  }
  if (!oldDashboardData[merchantId][activeType]) {
    return false;
  }
  if (!oldDashboardData[merchantId][activeType][date]) {
    return false;
  }
  if (!oldDashboardData[merchantId][activeType][date][chartKey]) {
    return false;
  }

  const data = oldDashboardData[merchantId][activeType][date][chartKey];
  return data;
};

export const deleteKey = (merchantId, activeType, presentDate, chartKey) => {
  // console.log("merchantId: ", merchantId);
  // console.log("activeType: ", activeType);
  // console.log("presentDate: ", presentDate);
  // console.log("chartKey: ", chartKey);
  if (presentDate && merchantId && activeType && chartKey) {
    // console.log("hi deleting...");
    const date = dateInYYYYMMDD(presentDate);
    // console.log("date: ", date);
    const dashboardData = sessionStorage.getItem("dashboardData");
    const oldDashboardData = dashboardData ? JSON.parse(dashboardData) : {};
    // console.log("oldDashboardData: ", oldDashboardData);

    const dashboardDataExists = dataExists(
      JSON.parse(JSON.stringify(oldDashboardData)),
      merchantId,
      activeType,
      date,
      chartKey
    );
    // console.log("dashboardDataExists: ", dashboardDataExists);

    if (Object.keys(dashboardDataExists).length > 0) {
      let newDashboardData = JSON.parse(JSON.stringify(oldDashboardData));
      // console.log("---before newDashboardData: ", newDashboardData);
      delete newDashboardData[merchantId][activeType][date][chartKey];
      // console.log("---after newDashboardData: ", newDashboardData);
      sessionStorage.setItem("dashboardData", JSON.stringify(newDashboardData));
    }
  }
};

export const dataIsMatching = (newData, oldData, key) => {
  let isMatching = true;

  if (
    !!!newData ||
    !!!oldData ||
    newData?.length <= 0 ||
    oldData?.length <= 0
  ) {
    return false;
  }

  for (let i = 0; i < oldData.length; i++) {
    if (oldData[i].uv !== newData[i][key]) {
      isMatching = false;
      break;
    }
  }
  return isMatching;
};

export const transactionType = (type) => {
  // console.log('type',type)
  if (type === "Cash") {
    return "Cash";
  } else if (type === "Credit Card") {
    return "Online";
  } else if (type === "Cash & Credit Card") {
    return "Both";
  } else {
    return type;
  }
};

export const formattedScheduleDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "long" });
  const year = date.getFullYear();

  const getOrdinalSuffix = (n) => {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
};

export const formatTimeOnly = (inputDate) => {
  // console.log("parsedTime",inputDate)
  const parsedTime = new Date(inputDate);
  if (isNaN(parsedTime.getTime())) {
    return <div>Error: Invalid time format</div>;
  }
  let hours = parsedTime.getHours();
  const minutes = String(parsedTime.getMinutes()).padStart(2, "0");
  const meridiem = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  hours = String(hours).padStart(2, "0");
  const formattedTime = `${hours}:${minutes} ${meridiem}`;
  return formattedTime;
};

/// all endpoints related to pages

export const endPointObj = {
  "sales-summary": SALES_REPORT_LIST,
  location: "",
  category: GET_TOP_CATEGORY_SALES_REPORT_LIST,
  "employee-sales": "",
  customers: NEW_CUSTOMER_REPORT,
  discount: DISCOUNT_SALES_TABLE_LIST,
  "hourly-sales-report-old": SALES_BY_HOURS_REPORT,
  "sales-by-hour": SALES_BY_HOURS_REPORT,
  items: GET_ITEMWISE_SALE_LIST,
  "daily-sales-totals-old": LIST_DAILY_REPORT,
  "sales-items-old": GET_ITEMWISE_SALE_LIST,
  "daily-totals": LIST_DAILY_REPORT,
  "order-type": LIST_ALL_ORDER_TYPE,
  "new-sales-by-order-type": LIST_ALL_ORDER_TYPE,
  "detailed-category-report": DETAIL_CATEGORY_SALE_REPORT,
  "detailed-sales-person-report": "",
  "top-seller": TOP_SALLER_REPORT,
  "order-refund-report": ORDER_REFUND_REPORT,
  "item-refund-report": "",
  "refund-report": "",
  "tip-report": TIP_REPORT_LIST,
  "coupon-report": COUPON_REPORT_LIST,
  "employee-sales-per-category-report": "",
  "category-sales-summary-report": "",
  "drop-cash": DROP_CASH_REPORT,
  "pay-in-report": PAY_IN_REPORT,
  "payment-method-details": "",
  "product-profitability-report": Product_Profitability_REPORT,
  "old-salesSummary-report": "",
  "new-customers-added-report": NEW_CUSTOMER_ADDED_REPORT,
  "employee-list": LIST_ALL_EMPLOYEE,
  "employee-working-hours": EMPLOYEE_WORK_HOURS,
  "employee-sales-per-category-report": EMPLOYEE_SALES_PER_CATEGORY_REPORT,
  "discount-per-sales-report": DISCOUNT_PER_PERSON,
  "sales-per-employee": EMPLOYEE_SALES_REPORT,
  "employee-sales-by-item": NET_SALES_BY_EMPLOYEE_REPORT,
  "payment-report": GET_PAYMENT_REPORT_DATA,
  "register-closures": GET_REGISTER_CLOSURE_LIST,
  "detailed-loyalty-points-report": DETAILED_LOYALTY_POINTS,
  "store-credit-report": STORE_CREDIT_REPORT,
  "gift-card-report": GIFT_CARD_REPORT,
  "new-taxes-report": NEW_TAXES_REPORT,
  "order-list": LIST_ALL_STORE_ORDER_LIST_NEW,
  "lottery-activity-report": LOTTERY_ACTIVITY_REPORT,
};

export const wordsWithInBetweenSpace = /^[A-Za-z0-9]+(?:\s+[A-Za-z0-9]+)*$/;

// Helper function to calculate isViewingCurrentPeriod for dashboard/detail views
// Used in dashboard and detail page hooks to determine if user is viewing current period
export const calculateIsViewingCurrentPeriod = (date, activeType) => {
  const d = date instanceof Date ? date : new Date(date);
  const today = new Date();
  const viewType = String(activeType || '').toLowerCase();
  // Day view: check if same day as today
  if (viewType === 'day') {
    return (
      d.getFullYear() === today.getFullYear() &&
      d.getMonth() === today.getMonth() &&
      d.getDate() === today.getDate()
    );
  }
  // Week view: check if current week (Monday-based)
  if (viewType === 'week') {
    const getWeekStartMonday = (date) => {
      const x = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const day = x.getDay();
      const diff = day === 0 ? -6 : 1 - day;
      x.setDate(x.getDate() + diff);
      x.setHours(0, 0, 0, 0);
      return x;
    };
    const weekStart = getWeekStartMonday(d);
    const currentWeekStart = getWeekStartMonday(today);
    return weekStart.getTime() === currentWeekStart.getTime();
  }
  // Month view: check if same month and year
  if (viewType === 'month') {
    return (
      d.getFullYear() === today.getFullYear() &&
      d.getMonth() === today.getMonth()
    );
  }
  // Default: return true for unknown types
  return true;
};

// Validation rules:
// - Only alphabets, numbers and spaces
// - No consecutive spaces
// - Trim starting spaces (keep middle typing smooth)
export const sanitizeName = (value) => {
  // Keep only letters, numbers & space
  let cleaned = value.replace(/[^A-Za-z0-9 ]/g, "");

  // Remove consecutive spaces
  cleaned = cleaned.replace(/\s+/g, " ");

  // Trim start (avoid leading spaces)
  cleaned = cleaned.trimStart();

  return cleaned;
};

// Copy to store (Mix & Match / BOGO edit)
// The list API returns the stores a deal has already been copied to in
// `linked_stores` as a comma separated list of merchant ids. On edit those
// stores are pre-selected and the user can add or remove stores as needed.
export const parseCopiedStoreIds = (deal) => {
  const raw = deal?.linked_stores ?? "";
  const list = Array.isArray(raw) ? raw : String(raw).split(",");
  return list
    .map((item) =>
      String(
        item && typeof item === "object" ? (item?.merchant_id ?? item?.id) : item
      ).trim()
    )
    .filter(Boolean);
};

// Maps those merchant ids onto the store objects of the copy to store dropdown.
export const getCopiedStores = (deal, storeList = []) => {
  const merchantIds = parseCopiedStoreIds(deal);
  if (!merchantIds.length || !storeList?.length) return [];
  return storeList.filter((store) =>
    merchantIds.includes(String(store?.merchant_id))
  );
};

// Saved-items guard (Mix & Match / BOGO)
// A deal stores its selection in `items` / `items_id` as a
// { productId: [variantId | ""] } map that keeps every id ever saved, including
// products and variants deleted since. `items_detail` is the resolved counterpart
// and only carries rows that still exist. Neither one alone is the selection:
// items_detail can list rows the deal never picked (siblings of a surviving
// product), and the raw map can list ids that no longer resolve. The chips are
// the intersection, so hydration walks items_detail and checks each row here.
export const parseDealItemsMap = (items) => {
  let parsed = items;
  if (typeof parsed === "string") {
    try {
      parsed = JSON.parse(parsed);
    } catch {
      return null;
    }
  }
  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
    return null;
  }
  const map = new Map();
  Object.entries(parsed).forEach(([productId, variantIds]) => {
    const list = Array.isArray(variantIds) ? variantIds : [variantIds];
    map.set(String(productId), new Set(list.map((id) => String(id ?? ""))));
  });
  return map.size ? map : null;
};

// True when the product/variant pair is part of the saved selection. A null map
// (missing or malformed `items`) means there is nothing to check against, so the
// row is kept — items_detail stays the source of truth as before.
// Non-variant products have been stored as [""], [null] and [productId] over the
// years, so all three forms count as saved.
export const isDealItemSaved = (itemsMap, productId, variantId) => {
  if (!itemsMap) return true;
  const savedVariantIds = itemsMap.get(String(productId));
  if (!savedVariantIds) return false;
  if (variantId) return savedVariantIds.has(String(variantId));
  return (
    savedVariantIds.has("") || savedVariantIds.has(String(productId))
  );
};

// Flat-amount discount guard (Mix & Match / BOGO)
// An item priced at or below the flat discount would ring up free or negative,
// so it can never be part of the deal. The product picker already hides those
// rows (the list API filters on `disc_amt`), but nothing stops a merchant from
// picking products first and raising the discount afterwards — this re-checks
// the already selected items against the current amount.
// Percentage discounts are exempt: they scale with the price, so no item can be
// over-discounted.
export const getItemsPricedBelowDiscount = (items, discountAmount) => {
  const discount = parseFloat(discountAmount);
  if (!Number.isFinite(discount) || discount <= 0) return [];
  return (Array.isArray(items) ? items : []).filter((item) => {
    const price = parseFloat(
      item?.isvarient === "1" ? (item?.var_price ?? item?.price) : item?.price
    );
    // Unknown price → leave it to the API rather than blocking the save.
    if (!Number.isFinite(price)) return false;
    return price <= discount;
  });
};

// Names the offending items in the blocking error so the merchant knows exactly
// which chips to remove. Long lists are truncated to keep the message readable.
export const buildDiscountPriceConflictMessage = (items, maxNames = 5) => {
  const names = (Array.isArray(items) ? items : [])
    .map((item) => String(item?.title ?? "").trim())
    .filter(Boolean);
  if (!names.length) return "";
  const shown = names.slice(0, maxNames);
  const remaining = names.length - shown.length;
  const list = remaining > 0
    ? `${shown.join(", ")} and ${remaining} more`
    : shown.join(", ");
  return `Discount is greater than or equal to the price of ${list}. Reduce the discount or remove ${
    names.length > 1 ? "these products" : "this product"
  } from the deal.`;
};

// True when the item is one of the conflicting rows, used to flag its chip.
export const isItemPricedBelowDiscount = (item, discountAmount) =>
  getItemsPricedBelowDiscount([item], discountAmount).length > 0;
